import React, {useRef, useEffect} from "react";
import styled from "@emotion/styled";
import Text from "../text/Text";
import Colors from "../../styles/Colors";

interface Option {
    label: string,
    value: string | number | boolean,
}

interface Props {
    options: Array<Option>,
    onChange: Function,
    defaultValue?: number,
    label?: string,
    isImportant?: boolean,
    name: string,
}

const RadioInput = (
    {
        options = [],
        onChange = () => null,
        defaultValue = 0,
        label = "",
        isImportant = false,
        name = "",
    }: Props
) => {
    const optionsRefs = useRef<Array<HTMLDivElement | null>>([])

    const setDefaultValueChecked = () => {
        const optionRef = optionsRefs.current[defaultValue]

        if (optionRef) {
            optionRef.classList.add("checked")
        }
    }

    const handleOnChange = (value: number) => {
        const optionRef = optionsRefs.current[value]

        // const elements = document.getEle(name)
        // console.log(elements)

        if (optionRef && !optionRef.classList.contains("checked")) {
            for (let i = 0; i < optionsRefs.current.length; i++) {
                const ref = optionsRefs.current[i]

                if (ref && ref.classList.contains("checked") && i !== value) {
                    ref.classList.remove("checked")
                }
            }

            optionRef.classList.add("checked")
        }

        onChange(options[value].value)
    }

    const renderOptions = () => {
        return <OptionsContainer>
            {
                options.map((option, index) => (
                    <OptionContainer
                        key={index}
                        onClick={() => handleOnChange(index)}
                        id={name}
                    >
                        <RadioButton ref={ref => optionsRefs.current[index] = ref}>
                            <div />
                        </RadioButton>
                        <Text>{option.label}</Text>
                    </OptionContainer>
                ))
            }
        </OptionsContainer>
    }

    useEffect(() => {
        optionsRefs.current = optionsRefs.current.slice(0, options.length);
        setDefaultValueChecked()
    });

    return (
        <Container>
            {
                label && <LabelContainer>
                    <Text>{label}</Text>
                    {isImportant && <Text color={Colors.green}>*</Text>}
                </LabelContainer>
            }

            {renderOptions()}
        </Container>
    )
}

export default RadioInput

const Container = styled.div`
  width: 100%;
  position: relative;
`

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;

  p {
    text-align: start;
  }
`

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
  
  p {
    text-align: start;
  }
  
  &:hover {
    cursor: pointer;
  }
  
  :first-of-type {
    margin-left: 0;
  }
`

const RadioButton = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border-radius: 8px;
  border: 1px solid ${Colors.darkGrey};
  padding: 2px;
  background: none;
  
  transition: linear;
  transition-duration: 200ms;
    
  &.checked > div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${Colors.green};
    box-shadow: ${Colors.radioShadow};
    background: radial-gradient(circle, ${Colors.green} 0%, ${Colors.lightGreen} 100%);
  }
`

